import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { chatroomId: Number }

  connect() {
    this.selectedPatientId = null
    this.selectedPatientName = null
  }

  toggle(event) {
    const chatroomId = this.chatroomIdValue
    const section = document.getElementById(`patient_search_section_${chatroomId}`)

    if (section) {
      // Toggle simple con display
      if (section.style.display === 'none' || section.classList.contains('collapse')) {
        section.style.display = 'block'
        section.classList.remove('collapse')
        // Enfocar el input
        const input = section.querySelector('input[type="text"]')
        if (input) input.focus()
      } else {
        section.style.display = 'none'
        section.classList.add('collapse')
      }
    }
  }

  handleUserClick(event) {
    // Interceptar clicks en los resultados del user-search
    const userResult = event.target.closest('.patient-assignment-search-result')
    if (userResult) {
      event.preventDefault()
      event.stopPropagation()

      const userId = userResult.dataset.userId
      const userName = userResult.dataset.userName

      // Guardar la selección
      this.selectedPatientId = userId
      this.selectedPatientName = userName

      // Actualizar el input con el nombre seleccionado
      const input = document.getElementById(`patient_search_${this.chatroomIdValue}`)
      if (input) {
        input.value = userName
      }

      // Habilitar el botón de asignación
      this.updateAssignButton(true)

      // Cerrar el dropdown
      const results = document.getElementById(`patient_search_results_${this.chatroomIdValue}`)
      if (results) {
        results.classList.add('d-none')
      }
    }
  }

  updateAssignButton(enabled) {
    const button = document.getElementById(`assign_patient_btn_${this.chatroomIdValue}`)
    if (button) {
      button.disabled = !enabled
      if (enabled) {
        button.classList.remove('btn-secondary')
        button.classList.add('btn-primary')
      } else {
        button.classList.remove('btn-primary')
        button.classList.add('btn-secondary')
      }
    }
  }

  assignSelectedPatient(event) {
    // Cambiar el paciente de un chat le saca el número a la ficha actual
    const reassignFrom = event.currentTarget.dataset.reassignFrom
    if (reassignFrom && !confirm(`El chat y su número pasan de ${reassignFrom} a ${this.selectedPatientName}. ¿Seguro?`)) {
      return
    }

    if (this.selectedPatientId && this.selectedPatientName) {
      this.assignPatient(this.selectedPatientId, this.selectedPatientName)
    }
  }

  async assignPatient(patientId, patientName) {
    const chatroomId = this.chatroomIdValue

    // Mostrar loading
    const resultsContainer = document.getElementById(`patient_search_results_${chatroomId}`)
    if (resultsContainer) {
      resultsContainer.innerHTML = '<div class="text-center py-3"><div class="spinner-border spinner-border-sm text-primary me-2"></div>Asignando paciente...</div>'
    }

    try {
      const response = await fetch(`/chatrooms/${chatroomId}/assign_patient`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({ patient_id: patientId })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      Turbo.renderStreamMessage(html)

      // Solo limpiar si la respuesta fue exitosa
      if (response.ok) {
        // Limpiar la selección
        this.selectedPatientId = null
        this.selectedPatientName = null

        // Limpiar el input
        const input = document.getElementById(`patient_search_${chatroomId}`)
        if (input) {
          input.value = ''
        }

        // Deshabilitar el botón
        this.updateAssignButton(false)

        // Cerrar la sección
        const section = document.getElementById(`patient_search_section_${chatroomId}`)
        if (section) {
          section.style.display = 'none'
          section.classList.add('collapse')
        }
      }
    } catch (error) {
      if (resultsContainer) {
        resultsContainer.innerHTML = `
          <div class="alert alert-danger d-flex justify-content-between align-items-center">
            <div>
              <i class="fas fa-exclamation-triangle me-2"></i>
              <strong>Error:</strong> No se pudo asignar el paciente. Intenta nuevamente.
            </div>
            <button type="button" class="close" onclick="this.parentElement.parentElement.remove()">&times;</button>
          </div>
        `
      } else {
        console.error('Results container not found!')
        // Fallback: mostrar alert en el frontend
        const section = document.getElementById(`patient_search_section_${chatroomId}`)
        if (section) {
          const errorDiv = document.createElement('div')
          errorDiv.className = 'alert alert-danger alert-dismissible fade show'
          errorDiv.innerHTML = `
            <i class="fas fa-exclamation-triangle me-2"></i>
            <strong>Error:</strong> No se pudo asignar el paciente. Intenta nuevamente.
            <button type="button" class="close" onclick="this.parentElement.remove()">&times;</button>
          `
          section.appendChild(errorDiv)
        }
      }
    }
  }
}
